
import { Helmet } from "react-helmet";
import NavigationButtons from '@/components/NavigationButtons';
import { ArrowRight, Github, Bot } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { WaitlistDialog } from "@/components/WaitlistDialog";

const DeepseekR1 = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>DeepSeek R1 - Advanced AI Model | DeepSeek.ai</title>
        <meta 
          name="description" 
          content="Experience DeepSeek R1, our advanced AI model. Explore our open source repository on GitHub." 
        />
      </Helmet>

      <main className="min-h-screen pt-24 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h1 className="text-4xl font-bold tracking-tight mb-4">DeepSeek R1</h1>
          <p className="text-xl text-gray-600 mb-8">
            Looking for DeepSeek R1? Click the link below!
          </p>
          
          <NavigationButtons />
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          <div className="p-6 rounded-xl bg-white shadow-lg">
            <h2 className="text-xl font-semibold mb-3">Open Source</h2>
            <p className="text-gray-600">
              Fully open source and available for the community to use, study, and improve.
            </p>
          </div>
          
          <div className="p-6 rounded-xl bg-white shadow-lg">
            <h2 className="text-xl font-semibold mb-3">Advanced Capabilities</h2>
            <p className="text-gray-600">
              Powerful language understanding and generation capabilities for diverse applications.
            </p>
          </div>
          
          <div className="p-6 rounded-xl bg-white shadow-lg">
            <h2 className="text-xl font-semibold mb-3">Community Driven</h2>
            <p className="text-gray-600">
              Join our growing community of developers and researchers working to advance AI technology.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="https://chromewebstore.google.com/detail/deepseek/inhcgfpbfdjbjogdfjbclgolkmhnooop"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-white bg-[#0066FF] hover:bg-[#0066FF]/90 transition-all shadow-[0_4px_14px_0_rgba(0,102,255,0.39)] hover:shadow-[0_6px_20px_rgba(0,102,255,0.23)] hover:transform hover:translate-y-[-1px]"
          >
            Download DeepSeek AI for Free!
            <ArrowRight className="ml-2 h-5 w-5" aria-hidden="true" />
          </a>
          <button
            onClick={() => setIsDialogOpen(true)}
            className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#0066FF] text-base font-medium rounded-full text-[#0066FF] bg-white hover:bg-blue-50 transition-all shadow-[0_4px_14px_0_rgba(0,102,255,0.39)] hover:shadow-[0_6px_20px_rgba(0,102,255,0.23)] hover:transform hover:translate-y-[-1px]"
          >
            Create AI Agents
            <Bot className="ml-2 h-5 w-5" aria-hidden="true" />
          </button>
        </div>
        </div>
      </main>
    </>
  );
};

export default DeepseekR1;
